<template>
  <div class="footer-links">
    <div class="ft-nav">
      <div class="fillerL0"> </div>
      <a href="/">
        <img src="../../public/TPicon.png" alt="Company Logo" class="company-logo">
      </a>
      <div class="fillerL1"> </div>
      <nav>
        <!-- <a href="/#/about">公司簡介</a>
        <a href="/#/parking-lots">停車場位置</a>
        <a href="/#/collaboration-page">委託與合作</a>
        <a href="/#/qna">常見Q&A</a> -->
        <router-link to="/about">公司簡介</router-link>
        <router-link to="/parking-lots">停車場位置</router-link>
        <router-link to="/collaboration-page">委託與合作</router-link>
        <router-link to="/qna">常見Q&A</router-link>
        <router-link to="/privacy-policy">隱私權政策</router-link>

      </nav>
    </div>
    <p class="copyright">Copyright © 2024 taiwan-parking.com.tw</p>
    <!-- <div class="fillerR0"> </div> -->

  </div>
</template>

<script>
export default {
  name: 'ContactFooter'
  
}
</script>

<style scoped>
.footer-links {

  width: 100%;
  height: 128px;

  background-color: var(--green05);
  color: white;


  display: flex;
  flex-direction: row;
  justify-content: space-between;

  align-items: center;
  /* padding: 20px 0; */
  /* text-align: center; */
}

.fillerL0 {
  height: 72px;
  width: 72px;
  /* initial width */
  min-width: 0;
  /* allow them to shrink to zero if necessary */
  flex-shrink: 1;
  /* allow shrinking */
  flex-grow: 0;
  /* prevent growing */
  flex-basis: auto;
  /* allow them to adapt */
}

.fillerL1 {
  height: 72px;
  width: 100px;
  /* initial width */
  min-width: 0;
  /* allow them to shrink to zero if necessary */
  flex-shrink: 1;
  /* allow shrinking */
  flex-grow: 0;
  /* prevent growing */
  flex-basis: auto;
  /* allow them to adapt */
}


.ft-nav {
  /* margin-top: 10px; */
  /* margin-left: 5rem; */
  display: flex;
  flex-direction: row;
  align-items: center;

  /* margin: auto 0px; */

  /* laout items in the center vertically */
  justify-content: center;

}

.company-logo {
  width: 72px;
  height: 72px;

  /* margin: auto 0px; */
  margin-top: 12px;
  margin-right: 0px;

  /* margin-bottom: 20px; */
  /* margin-right: 1rem; */
}


nav {
  margin-bottom: 0px;

  /* alow only one line of text */
  white-space: nowrap;
}

nav a {
  color: white;
  text-decoration: none;
  margin-right: 24px;

  font-size: 14px;
  font-weight: 700;
}

.copyright {
  font-size: 14px;
  font-weight: 400;
  /* margin-right: 72px; */
  margin-right: 4%;

  text-wrap: nowrap;
}




@media (max-width: 800px) {}

@media (max-width: 560px) {

  .footer-links {

    width: 100%;
    height: 416px;

    

    background-color: var(--green05);
    color: white;


    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */

    align-items: flex-start;
    /* padding: 20px 0; */
    /* text-align: center; */
  }

  .fillerL0 {
    height: 10px;
    width: 72px;
    /* initial width */
    min-width: 0;
    /* allow them to shrink to zero if necessary */
  }

  .fillerL1 {
    height: 12px;
    width: 72px;
    /* initial width */
    min-width: 0;
    /* allow them to shrink to zero if necessary */
  }



  .ft-nav {
    margin-left:16px;
    /* margin-top: 10px; */
    /* margin-left: 5rem; */
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    /* margin: auto 0px; */

    /* laout items in the center vertically */
    justify-content: center;

  }

  .company-logo {
    width: 48px;
    height: 48px;

    /* margin: auto 0px; */
    margin-top: 12px;
    /* margin-bottom: 12px; */
    margin-right: 0px;

    /* margin-bottom: 20px; */
    /* margin-right: 1rem; */
  }


  nav {
    margin-bottom: 0px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* alow only one line of text */
    /* white-space: nowrap; */
  }

  nav a {
    color: white;
    text-decoration: none;
    margin-bottom: 20px;

    font-size: 14px;
    font-weight: 700;
  }

  .copyright {
    font-size: 14px;
    font-weight: 400;
    /* margin-right: 72px; */
    margin-left:16px;
    margin-bottom:24px;

    text-wrap: nowrap;
  }





}

@media (max-width: 360px) {}
</style>